import { ChevronRight, Clock, Inbox, Pencil } from "lucide-react";

export const isPendingRequest = (q) =>
  q.source === "online_link" && q.status !== "Reddedildi" && !(Number(q.premium) > 0) && !(q.offers || []).some((o) => Number(o.premium) > 0);

const waitHours = (q) => (Date.now() - new Date(q.createdAt || Date.now()).getTime()) / 36e5;

export const waitLabel = (q) => {
  const h = waitHours(q);
  if (h < 1) return `${Math.max(1, Math.round(h * 60))} dk`;
  if (h < 24) return `${Math.floor(h)} saat`;
  const d = Math.floor(h / 24);
  const r = Math.floor(h % 24);
  return r ? `${d} gün ${r} saat` : `${d} gün`;
};

export function WaitBadge({ q }) {
  const late = waitHours(q) >= 24;
  return (
    <span className={`wait-badge ${late ? "late" : ""}`} title="Talep geldiğinden beri geçen süre" data-testid={`wait-badge-${q.id}`}>
      <Clock size={10} /> {waitLabel(q)} bekliyor
    </span>
  );
}

export function NewRequestsCounter({ quotes = [], onOpen, onPrepare }) {
  const pending = quotes.filter(isPendingRequest).sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0));
  const n = pending.length;
  const oldest = pending[0];
  const late = pending.filter((q) => waitHours(q) >= 24).length;
  return (
    <div className={`req-counter ${n ? "has" : ""}`} data-testid="dashboard-new-requests-card">
      <button type="button" className="req-counter-main" onClick={onOpen} data-testid="dashboard-new-requests">
        <span className="req-counter-icon"><Inbox size={18} /></span>
        <span className="req-counter-text">
          <strong>{n ? "Yanıt bekleyen online talepler" : "Bekleyen online talep yok"}</strong>
          <small data-testid="dashboard-new-requests-latest">
            {oldest ? `En eski: ${oldest.customerName || "İsimsiz"} · ${waitLabel(oldest)}` : "Linkten gelen tüm talepler teklife dönüştü"}
            {late > 0 && <em className="req-late" data-testid="dashboard-new-requests-late"> · {late} talep 24 saati geçti</em>}
          </small>
        </span>
        <b className="req-counter-num" data-testid="dashboard-new-requests-count">{n}</b>
        <ChevronRight size={16} className="req-counter-go" />
      </button>
      {oldest && onPrepare && (
        <button type="button" className="req-counter-quick" onClick={() => onPrepare(oldest)} data-testid="dashboard-prepare-oldest-request">
          <Pencil size={13} /> En eskiye teklif hazırla
        </button>
      )}
    </div>
  );
}
